import { createContext, type RefObject } from "react";

// Where the pending approval prompt puts its element, so the conversation can scroll to it when a turn ends on it.
export const PendingPromptContext = createContext<RefObject<HTMLDivElement | null> | null>(null);
